<template>
  <div class="ctrl-100 ctrl">
    <el-button
      class="ctrl-btn"
      @click="toggleVisibility"
      :class="{ active: whiteBoardFormVisible }"
      type="text"
    >
      <IconBase
        class="ctrl-icon"
        :height="32"
        :width="32"
        :view-box="`0 0 32 32`"
        :fill="sharedLinks.length > 0 ? '#50C6DF' : '#E7E6FA'"
      >
        <IconLink />
      </IconBase>
      <span :class="{ active: sharedLinks.length > 0 }">Share link</span>
    </el-button>
    <div
      class="ctrl-window__overlay"
      v-if="whiteBoardFormVisible"
      @click="whiteBoardFormVisible = false"
    ></div>
    <transition name="fade">
      <div class="ctrl-window" v-if="whiteBoardFormVisible" width="300px">
        <div class="ctrl__header">
          <h3 class="ctrl__title">Share link</h3>
          <div @click="whiteBoardFormVisible = false">
            <IconBase
              :height="24"
              :width="24"
              :view-box="`0 0 24 24`"
              :fill="'#E7E6FA'"
            >
              <IconCross />
            </IconBase>
          </div>
        </div>
        <div v-if="sharedLinks.length" style="margin-bottom: 8px">
          Links shared in this room
        </div>
        <div class="links">
          <div v-for="(link, index) in sharedLinks" :key="index">
            <EditLink
              :link="link"
              :index="index"
              @link-deleted="deleteSharedLink"
            />
          </div>
        </div>
        <hr class="divider" />
        <p>Add link you want to share</p>
        <div class="ctrl__form">
          <el-form @submit.prevent.native="addLink" :model="whiteBoard">
            <el-row>
              <el-col :span="20">
                <el-input
                  class="add-link-input"
                  :span="10"
                  placeholder="e.g. https://www.berst.io"
                  v-model="inputLink"
                  size="small"
                  @input="resetMessages"
                >
                </el-input>
              </el-col>
              <el-col :span="4">
                <el-button class="add-button" @click="addLink">
                  <IconBase
                    :height="24"
                    :width="24"
                    :view-box="`0 0 24 24`"
                    :fill="'#E7E6FA'"
                  >
                    <IconPlus />
                  </IconBase>
                  <span class="button-text">
                    Add
                  </span>
                </el-button>
              </el-col>
            </el-row>
            <div class="success-text">
              <transition name="fade">
                <span v-if="linkAdded">Link added!</span>
              </transition>
            </div>
            <div class="error-text">
              <transition name="fade">
                <span v-if="invalid">Invalid link!</span>
              </transition>
            </div>
          </el-form>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import IconBase from "../IconBase";
import IconLink from "../icons/IconLink";
import IconCross from "../icons/IconCross";
import IconPlus from "../icons/IconPlus";
import EditLink from "./EditLink";
import { mapState, mapGetters } from "vuex";
import { getSocketPayload } from "../../utils";

export default {
  name: "WhiteBoard",
  components: {
    IconBase,
    IconLink,
    IconCross,
    IconPlus,
    EditLink
  },
  data: function() {
    return {
      whiteBoard: {
        url: ""
      },
      inputLink: null,
      sharedLinks: [],
      whiteBoardFormVisible: false,
      invalid: false,
      linkAdded: false,

      linkTimeout: null
    };
  },

  methods: {
    setSharedLinks() {
      const socketRoom = this.getRoom(this.currentRoom._id);
      this.sharedLinks =
        (socketRoom && JSON.parse(JSON.stringify(socketRoom.sharedLinks))) ||
        []; // deepcopy hack
    },

    toggleVisibility() {
      this.whiteBoardFormVisible = !this.whiteBoardFormVisible;
      if (this.whiteBoardFormVisible) {
        this.setSharedLinks();
      }
    },
    validLink(link) {
      // eslint-disable-next-line no-useless-escape
      const regExp = RegExp(
        // eslint-disable-next-line no-useless-escape
        /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
      );
      return link && link.match(regExp);
    },
    addLink() {
      const isValid = this.validLink(this.inputLink);
      clearTimeout(this.linkTimeout);
      if (isValid) {
        this.sharedLinks.push(this.inputLink);
        this.linkAdded = true;
        this.inputLink = null; // reset
        this.saveSharedLinks();
        this.linkTimeout = setTimeout(this.resetMessages, 1000);
      } else {
        this.invalid = true;
      }
    },
    deleteSharedLink(index) {
      this.$delete(this.sharedLinks, index);
      this.saveSharedLinks();
    },
    saveSharedLinks() {
      this.socket.emit(
        "UPDATE_ROOM",
        getSocketPayload({
          event: "WHITEBOARD",
          mainRoom: this.mainRoom.name,
          token: this.tokens ? this.tokens["idToken"] : null,
          sharedLinks: this.sharedLinks
        })
      );
    },
    cancelwhiteBoardForm() {
      this.whiteBoardFormVisible = false;
    },
    resetMessages() {
      this.linkAdded = false;
      this.invalid = false;
    }
  },
  computed: {
    ...mapState({
      currentRoom: state => state.rooms.currentRoom,
      mainRoom: state => state.rooms.mainRoom,
      tokens: state => state.user.tokens
    }),
    ...mapGetters("rooms", {
      socket: "getSocket",
      getRoom: "getRoomByGetter"
    })
  },
  watch: {
    currentRoom() {
      this.setSharedLinks();
    }
  }
};
</script>

<style>
.remove-link-dialog .el-dialog__body {
  display: none;
}
</style>

<style scoped>
.white-board {
  fill: #f7f7f7;
}

.white-board:hover,
.white-board-active {
  fill: #409eff;
}

.el-radio {
  float: left;
}

.link-open-type {
  padding-top: 12px;
  margin-left: -83px;
}
.ctrl-icon {
  display: block;
}
.remove-link__body {
  padding: 10% 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.remove-link-text {
  font-size: 16px;
  line-height: 21px;
  margin-bottom: 20px;
}
.ctrl-window {
  width: calc(480px - 24px) !important; /* exclude padding */
  height: auto !important;
}
.el-input.add-link-input {
  width: 380px;
  height: 36px;
  background: #393752;
  border-radius: 3px;
}

.el-button.add-button,
.el-button.add-button:hover {
  padding: 0;
  margin: 0;
  position: relative;
  left: -25px;
  width: 91px;
  height: 36px;
  background: #2a2a3d;
  border: 1px solid #e7e6fa;
  box-sizing: border-box;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #e7e6fa;
}
>>> button.el-button.add-button span,
>>> button.el-button.add-button.is-disabled span {
  display: flex;
  justify-content: center;
  align-items: center;
}
.button-text {
  padding: 3px 0px 0 10px;
}
.divider {
  height: 0px;
  width: 100%;
  border: 1px solid #393752;
}

div.ctrl-window {
  padding: 0 12px;
}

div.error-text,
div.success-text {
  display: inline-block;
  font-size: 14px;
  font-weight: normal;
  line-height: 23px;
}

div.error-text {
  color: #e05a5a;
}

div.success-text {
  color: #5ae05a;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.links {
  max-height: 250px;
  overflow-y: auto;
}

span.active {
  color: #50c6df;
}

button.ctrl-btn.el-button:hover span.active,
button.ctrl-btn.el-button.active span.active {
  color: #1c1c29;
}
</style>
